var _g, _text, _text2, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEpiphanymdLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 260 56",
    width: 260,
    height: 56,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(28,28)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -17,
    x2: 0,
    y2: -22,
    stroke: "#0F6E56",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: -8.5,
    x2: 18.5,
    y2: -10.5,
    stroke: "#0F6E56",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 8.5,
    x2: 18.5,
    y2: 10.5,
    stroke: "#0F6E56",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 17,
    x2: 0,
    y2: 22,
    stroke: "#0F6E56",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: -15,
    y1: 8.5,
    x2: -18.5,
    y2: 10.5,
    stroke: "#0F6E56",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: -15,
    y1: -8.5,
    x2: -18.5,
    y2: -10.5,
    stroke: "#0F6E56",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,-15 13,-7.5 13,7.5 0,15 -13,7.5 -13,-7.5",
    fill: "#0F6E56"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 5.5,
    fontFamily: "Georgia, serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "white",
    textAnchor: "middle"
  }, "E"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 23,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    fontSize: 17,
    fontWeight: 700,
    fill: "#f1f5f9",
    letterSpacing: -0.3
  }, "Epiphany")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 41,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    fontSize: 13,
    fontWeight: 500,
    fill: "#0F6E56",
    letterSpacing: 1.5
  }, "MD")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 58,
    y1: 27,
    x2: 240,
    y2: 27,
    stroke: "#0F6E56",
    strokeWidth: 0.5,
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpiphanymdLogo);
export default __webpack_public_path__ + "static/media/epiphanymd-logo.ab1516e3fb7b08127aa00e989d8e946f.svg";
export { ForwardRef as ReactComponent };